import React, { useCallback, useState, useContext } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';
import UserContext from '../../contexts/UserContext';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';

import { CREATE_BANK_ACCOUNT } from './queries';

export const BANK_ACCOUNT_TYPES = ['checking', 'savings']

export const FIELDS = {
  accountName: {
    rules: { required: true },
  },
  bankName: {
    rules: { required: true },
  },
  routingNumber: {
    label: 'Routing Number',
    blank: 'null',
    rules: { required: true },
  },
  accountNumber: {
    label: 'Account Number',
    blank: 'null',
    rules: { required: true },
  },
  type: {
    select: BANK_ACCOUNT_TYPES,
    label: 'Type',
    rules: { required: true },
  }
};

const NewBankAccount = ({ ownerType, ownerId, setShowModal, refetch }) => {
  const { userId } = useContext(UserContext);
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const [createAccount] = useMutation(CREATE_BANK_ACCOUNT, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setFormStatus('submitting');
    input['ownerType'] = ownerType;
    input['ownerId'] = ownerId;
    input['createdByType'] = 'User';
    input['createdById'] = userId;
    createAccount({ variables: prepareInput(input, FIELDS) });
  });

  const fields = { ...FIELDS };

  return (
    <View>
      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />

      <ButtonGroup>
        <Button label="Create Bank Account" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default NewBankAccount;
